module.exports = __webpack_public_path__ + "static/media/How to create Task.660b04e0.png";